import Head from 'next/head';
import { FunctionComponent, PropsWithChildren, useMemo } from 'react';
import BodyWithStyle from '../../components/BodyWithStyle';
import Container from '../../components/Container';
import Layout, { LayoutProps } from '../Layout';
import { Graph } from 'schema-dts';

export type CoursesLayoutProps = PropsWithChildren<
    LayoutProps & {
        schema: Graph;
        noIndex?: boolean;
        page: number;
        canonicalPath: string;
    }
>;

export const CoursesLayout: FunctionComponent<CoursesLayoutProps> = ({
    title,
    description,
    path,
    schema,
    page,
    canonicalPath,
    noIndex = false,
    children,
}) => {
    const imageUrl = useMemo(() => {
        const tidyTitle = title.replace(' - Cademy', '');
        return `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/og/courses?text=${encodeURIComponent(tidyTitle)}`;
    }, [title]);

    const cannonical = useMemo<string>(() => {
        if (page && page > 1) {
            return `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/${canonicalPath}?page=${page}`;
        }

        return `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/${canonicalPath}`;
    }, [page, canonicalPath]);

    return (
        <Layout
            title={title}
            description={description}
            path={path}
            image={imageUrl}
            themeColor="#FFFFFF"
        >
            <Head>
                <link rel="canonical" href={cannonical} />
                {noIndex ? <meta name="robots" content="noindex" /> : null}
                <script
                    id="results-schema"
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(schema),
                    }}
                />
            </Head>

            <BodyWithStyle />

            <Container>{children}</Container>
        </Layout>
    );
};

export default CoursesLayout;
